import { render } from "./serviceAdvantages.vue?vue&type=template&id=4bb1e6e0&scoped=true"
const script = {}

import "./serviceAdvantages.vue?vue&type=style&index=0&id=4bb1e6e0&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb1e6e0"]])

export default __exports__